import moment from 'moment';

export const isYoungerThan = (value: string, age: number) => {
    return moment(value, 'YYYY-MM-DD').isAfter(moment().subtract(age, 'years'));
};
